module.exports = __webpack_public_path__ + "static/img/far2.e4f0b9d1.png";